import React from 'react'
import "./Subscription.css"
// import zlogo from "../../media/z.png"
import Log from "../../media/videoFont.png"
import Gratuit from "../../media/normal.png"
import ROYAL from "../../media/prem.png"
import { Link } from 'react-router-dom'

const Payment = () => {
  
    return (
      <div className="min-h-screen bg-cover bg-no-repeat bg-center px-4 py-8" style={{ backgroundImage: `url(${Log})` }}>
        {/* Header */}
        <div className="max-w-7xl mx-auto flex items-center justify-center mb-8">
          <h2 className="text-2xl md:text-3xl text-white font-medium">
            Profitez de la version Premium avec des accès exclusifs pour votre voyage sur <span className="text-yellow-400">Zemus</span>:
          </h2>
        </div>
        <Link to={"/"}><span className="material-symbols-outlined absolute top-4 right-4 text-white text-3xl cursor-pointer hover:text-gray-300 transition-colors">
        home
        </span></Link>
  
        {/* Cards Container */}
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-8 justify-center items-stretch mb-12">
          {/* Free Version Card */}
          <div className="relative bg-white rounded-[4vw] shadow-lg w-full md:w-96 mt-16">
            {/* Logo qui dépasse */}
            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
              <img src={Gratuit} alt="Version gratuite" className="w-32" />
            </div>
            
            {/* Bande blanche au-dessus du header */}
            <div className="pt-10 pb-0 rounded-t-lg">
              {/* Espace pour le logo */}
            </div>
            
            {/* Header bleu */}
            <div className="bg-[#009AAD] py-4 text-center rounded-t-[1.5vw]">
              <h3 className="text-xl text-white font-medium">Zemus Free</h3>
            </div>
            
            <div className="p-6">
              <div className="flex items-center justify-around mb-6">
                <div className="flex flex-col">
                  <p className="text-xl font-medium">0.00 <span className="text-[#009AAD]">€</span> / au mois</p>
                </div>
              </div>
              <ul className="text-left space-y-2">
                <li className="before:content-['•'] before:text-[#7da3e0] before:mr-2">Recherche dans chaque pays</li>
                <li className="before:content-['•'] before:text-[#7da3e0] before:mr-2">Recherche dans sa langue (mots-clefs) d'informations en langues étrangères</li>
                <li className="before:content-['•'] before:text-[#7da3e0] before:mr-2">Rechercher et consulter les profils d'autres membres de Zemus</li>
              </ul>
            </div>
          </div>
  
          {/* Premium Version Card */}
          <div className="relative bg-white rounded-[4vw] shadow-lg w-full md:w-[640px] mt-16">
            {/* Logo qui dépasse */}
            <div className="absolute -top-16 left-1/2 transform -translate-x-1/2">
              <img src={ROYAL} alt="Version premium" className="w-40" />
            </div>
            
            {/* Bande blanche au-dessus du header */}
            <div className="pt-10 pb-0 rounded-t-lg">
              {/* Espace pour le logo */}
            </div>
            
            {/* Header jaune */}
            <div className="bg-yellow-400 py-4 text-center rounded-t-[1.5vw]">
              <h3 className="text-xl text-white font-medium">Zemus Premium</h3>
            </div>
            
            <div className="p-6">
              <div className="flex items-center justify-around mb-6">
                <div className="flex flex-col">
                  <p className="text-xl font-medium">9.00 <span className="text-yellow-400">€</span> / au mois</p>
                  <p className="text-xl font-medium">7.00 <span className="text-yellow-400">€</span> etudiant et demandeur</p>
                </div>
              </div>
              <ul className="text-left space-y-2 font-medium">
                {[
                  'Recherche dans chaque pays',
                  'Recherche dans sa langue (mots-clefs) d\'informations en langues étrangères',
                  'Suivi et partage des articles de presse',
                  'Archivage d\'articles favoris',
                  'Suivi thématique de la presse par pays',
                  'Réalisation et publication de revues de presse',
                  'Rechercher et consulter les profils d\'autres membres de Zemus',
                  'Suivre les pays et les thématiques de votre choix'
                ].map((feature, index) => (
                  <li key={index} className="before:content-['•'] before:text-[#7da3e0] before:mr-2">{feature}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
  
        {/* Footer */}
        <div className="text-center">
          <button 
            onClick={() => window.location.href = "/addsubscription"} 
            className="bg-yellow-400 text-black font-medium px-8 py-3 rounded-full text-lg hover:bg-yellow-600 transition-colors mb-4"
          >
            Passer a la version Premium
          </button>
          <div>
            <button
              onClick={() => window.location.href = "/purchase-countries"}
              className="bg-[#009AAD] text-white font-medium px-8 py-3 rounded-full text-lg hover:bg-[#007d8b] transition-colors"
            >
              Acheter des pays a l'unite
            </button>
          </div>
        </div>
      </div>
    );
  };

export default Payment